import { assetUrl, shareCaptureAssetUrl } from "~/utils/assetUrl"
import { archetypeImageUrl } from "~/utils/archetypeImageUrl"
import type { DogPortraitInfo } from "~/api/auth"

export function heroPortraitUrl(
  archetypeIcon: string | null | undefined,
  portrait?: DogPortraitInfo | null,
): string | null {
  if (portrait?.status === "ready" && portrait.url) {
    if (portrait.url.startsWith("http")) {
      // Absolute Active Storage URLs still need same-origin proxy for reliable pixels.
      if (portrait.url.includes("/rails/active_storage/")) {
        return shareCapturePath(portrait.url)
      }
      return portrait.url
    }
    if (portrait.url.startsWith("/share-assets/")) return portrait.url
    // Active Storage blobs: proxy via /share-assets so naturalWidth > 0 even when
    // blob redirects to S3 fail in the browser.
    if (portrait.url.includes("/rails/active_storage/")) {
      return shareCapturePath(portrait.url)
    }
    return assetUrl(portrait.url)
  }
  if (!archetypeIcon) return null
  return archetypeImageUrl(archetypeIcon, "portraits")
}

function isShareProxyablePath(path: string): boolean {
  return path.startsWith("/rails/active_storage/") || path.startsWith("/images/")
}

function shareCapturePath(url: string): string {
  if (url.startsWith("/share-assets/")) return url
  if (url.startsWith("http://") || url.startsWith("https://")) {
    const path = new URL(url).pathname
    if (!isShareProxyablePath(path)) return url
    return `/share-assets${path}`
  }
  const normalized = url.startsWith("/") ? url : `/${url}`
  return `/share-assets${normalized}`
}

/** @deprecated Prefer heroPortraitUrl — it now returns display-safe URLs. */
export function heroPortraitDisplayUrl(
  archetypeIcon: string | null | undefined,
  portrait?: DogPortraitInfo | null,
): string | null {
  return heroPortraitUrl(archetypeIcon, portrait)
}

export function heroPortraitShareUrl(
  archetypeIcon: string | null | undefined,
  portrait?: DogPortraitInfo | null,
): string | null {
  const url = heroPortraitUrl(archetypeIcon, portrait)
  if (!url) return null
  if (url.includes("/rails/active_storage/") || url.startsWith("http://") || url.startsWith("https://")) {
    return shareCapturePath(url)
  }
  if (url.startsWith("/share-assets/")) return url
  return shareCaptureAssetUrl(url.startsWith("/") ? url : `/${url}`)
}

